import React, { useEffect, useRef, useState } from 'react';
import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../../authConfig';
import Bobinas2 from '../../../assets/Bobinas2.jpg';

const UnauthenticationTemplateBody = () => {
  const { instance, inProgress } = useMsal();
  const autoLoginAttempted = useRef(false);
  const [loginError, setLoginError] = useState(false);

  useEffect(() => {
    // MSAL may render the configured redirect URI in a hidden iframe during
    // silent token renewal. Never start an interactive B2C redirect there.
    if (window.self !== window.top) return;
    if (inProgress !== InteractionStatus.None || autoLoginAttempted.current) return;

    // Start login after MSAL has finished processing redirect responses, not
    // while React renders and not through a Router outside BrowserRouter.
    autoLoginAttempted.current = true;
    instance.loginRedirect(loginRequest).catch(() => setLoginError(true));
  }, [instance, inProgress]);

  const retryLogin = () => {
    setLoginError(false);
    instance.loginRedirect(loginRequest).catch(() => setLoginError(true));
  };

  return (
    <div className="App">
      <header className="App-header" style={{ backgroundImage: `url(${Bobinas2})` }}>
        <p>{loginError ? 'No se pudo iniciar sesión. Volvé a intentarlo.' : 'Ingresando al portal de Corte-Chap...'}</p>
        {loginError && (
          <button type="button" onClick={retryLogin} disabled={inProgress !== InteractionStatus.None}>
            Iniciar sesión
          </button>
        )}
      </header>
    </div>
  );
};

export default UnauthenticationTemplateBody;
